import { Controller } from "stimulus"
const sumErrorClass = 'sum-error';

export default class extends Controller {
  static targets = [
    'updateDomId', 
    'debitSum', 
    'creditSum', 
    'debitField', 
    'creditField',
    'chartQueryDropdown',
    'triggerChartQueryLink',
    'entryFieldRow',
    'submit'
    ];

  connect() {
    this.updateForm();
  }

  setUpdateDomId() {
    this.updateDomIdTarget.value = this.element.id;
  }

  hideChartQueryDropdown() { this.chartQueryDropdownTarget.classList.add('hidden'); this.activeChartQueryInput = null; }
  showChartQueryDropdown(event) { this.chartQueryDropdownTarget.innerHTML = ''; this.chartQueryDropdownTarget.classList.remove('hidden'); this.placeDropdownUnderTarget(event); }
  placeDropdownUnderTarget(event) {
    this.chartQueryDropdownTarget.style.top = this.activeChartQueryInput.getBoundingClientRect().bottom + window.scrollY + "px";
  }

  dropDownIsVisible() {
    return !(this.chartQueryDropdownTarget.classList.contains('hidden') || this.chartQueryDropdownTarget.children.length == 0);
  }

  triggerChartQuery(event) {
    if(event.target.readOnly) { return; }
    var url = this.triggerChartQueryLinkTarget.href.split('?')[0];
    var query = event.target.value;
    this.triggerChartQueryLinkTarget.href = url + '?query=' + encodeURIComponent(query);
    this.activeChartQueryInput = event.target;
    this.showChartQueryDropdown(event);
    this.triggerChartQueryLinkTarget.click();
    if(event.target.value == '' || event.target.value.length < 4) { this.clearActiveAccountDescription(); }
  }

  clearActiveAccountDescription() {
    this.activeChartQueryInput.nextElementSibling.value = '';
  }

  // This is called on ajax load, and will then be passed an event, which is also when we reset it to 0
  // When called manually from inside this controller, num_or_event should be 1 (increase by one) or -1 (decrease by one)
  setActiveAccount(num_or_event) {
    // Is the dropdown active?
    if(this.dropDownIsVisible() && this.activeChartQueryInput) {
      var selection_elements = this.chartQueryDropdownTarget.getElementsByClassName('account-selection-leaf');
      this.activeAccount = num_or_event.target ? 0 : Math.min(Math.max(0, this.activeAccount + num_or_event), selection_elements.length);
      if(selection_elements[this.activeAccount]) {
        Array.from(selection_elements).forEach(elem => elem.classList.remove('selected'));
        selection_elements[this.activeAccount].classList.add('selected');
      }
    }
  }

  currentAccountSelectionElement() {
    var selection_elements = this.chartQueryDropdownTarget.getElementsByClassName('account-selection-leaf');
    return selection_elements[this.activeAccount];
  }

  clickAnywhere(event) {
    if(this.hasChartQueryDropdownTarget) {
      // Click inside chartQueryDropdown
      if(this.chartQueryDropdownTarget.contains(event.target)) {
        var accountSelectionElement = event.target.closest('.account-selection')
        if(accountSelectionElement) { this.selectAccount(accountSelectionElement); }
      // Click outside that isn't on the trigger link or in the currently active input
      } else if(!this.triggerChartQueryLinkTarget.contains(event.target) && (this.activeChartQueryInput && !this.activeChartQueryInput.contains(event.target))) {
        this.hideChartQueryDropdown();
      }
    }
  }

  selectAccount(accountSelectionElement) {
    if(!accountSelectionElement) { return; } // Happens when the dropdown is open, but no selectable account is show, like on top level or empty search
    var selectedAccountNumber = accountSelectionElement.dataset.accountNumber;
    if(selectedAccountNumber.length == 4) {
      this.activeChartQueryInput.value = selectedAccountNumber;
      this.activeChartQueryInput.nextElementSibling.value = accountSelectionElement.dataset.accountDescription;
      this.activeChartQueryInput.nextElementSibling.nextElementSibling.select();
      this.hideChartQueryDropdown();
    } else if(selectedAccountNumber.length < 4) {
      this.activeChartQueryInput.value = selectedAccountNumber;
      this.clearActiveAccountDescription();
      this.activeChartQueryInput.dispatchEvent(new Event('input'));
    }
  }

  accountNumberHandleTabOrEnter(e) {
    if(this.dropDownIsVisible()) {
      //console.log('There is an active chart query input!')
      event.preventDefault();
      event.stopPropagation();
      this.selectAccount(this.currentAccountSelectionElement());
      this.hideChartQueryDropdown();
    }
    if(e.target.parent && e.target.parent.classList.includes('entry-fields-row')) {
      e.target.select();
    }
  }

  accountNumberKeyDown(e) {
    switch (e.key) {
      case 'Escape':
        this.hideChartQueryDropdown();
        break;
      case 'Tab':
      case 'Enter':
        this.accountNumberHandleTabOrEnter(e);
        break;
      case 'ArrowUp':
        this.setActiveAccount(-1);
        break;
      case 'ArrowDown':
        this.setActiveAccount(1);
        break;
    }
  }

  creditColumnHandleTabOrEnter(e) {
    var creditField = e.target;
    var debitField = creditField.previousElementSibling;

    if(debitField.value == "" && creditField.value == "") {
      var diff = this.debitCreditDiff();
      if (diff.cmp(Big('0')) != 0) { // Is there a diff?
        e.preventDefault();
        this.autoFillDebitCredit(creditField, debitField, diff);
        this.focusOnFirstEmptyRow();
      }
    }
  }

  debitCreditDiff() {
    var [debitSum, creditSum] = this.sumColumns();
    return debitSum.minus(creditSum);
  }

  autoFillDebitCredit(creditField, debitField, diff) {
    if (diff.gt(Big('0'))) {
      creditField.value = diff.abs().toString();
      this.debitOrCreditChanged();
    } else if(diff.lt(Big('0'))) {
      debitField.value = diff.abs().toString();
      this.debitOrCreditChanged();
    }
  }

  creditColumnKeyDown(e) {
    switch (e.key) {
      case 'Tab':
      case 'Enter':
        this.creditColumnHandleTabOrEnter(e);
        break;
    }
  }

  updateForm() {
    this.setUpdateDomId();
    this.sanitizeMoneyInputs();
    this.sumAndCompareColumns();
    //this.focusOnFirstEmptyRow();
  }

  // We do almost exactly the same as on connect, except we also check if we need to add a new row
  debitOrCreditChanged(event = null) {
    this.emptyOtherDebitOrCredit(event);
    this.moveIfNegated(event);
    this.updateForm();
    this.ensureLastRowIsEmpty();
    this.focusOnFirstEmptyRow();
  }

  getOtherField(input_element) {
    if(input_element.id.match(/debit/)) {
      return input_element.nextElementSibling;
    } else {
      return input_element.previousElementSibling;
    }
  }

  // Makes it easy to move a value from one column to the other by entering a negative number
  moveIfNegated(event) {
    if(!event) { return; }
    const changedField = event.target;
    if(parseInt(changedField.value) < 0) {
      this.getOtherField(changedField).value = changedField.value.substring(1); // Removes the first char
      changedField.value = '';
    }
  }

  emptyOtherDebitOrCredit(event) {
    if(!event) { return; }
    const changedField = event.target;
    this.getOtherField(changedField).value = '';
  }

  ajaxComplete(event) {
    this.setActiveAccount(event);
  }

  focusOnFirstEmptyRow() {
    var firstEmptyRow = this.entryFieldRowTargets.filter(row => this.rowIsEmpty(row))[0]
    if(firstEmptyRow) {
      Array.from(firstEmptyRow.getElementsByTagName('input'))[0].focus();
    }
  }

  // Currently not used, but fully functioning in case we want/need it later
  // updateFormWithAjax() {
  //   //document.getElementById('main_flashes').innerHTML = '';
  //   this.element.dataset.remote = 'true'; // I think this form is actually always remote, so maybe not needed?
  //   this.element.action = this.element.dataset.reloadUrl;
  //   this.element.method = 'get';
  //   this.submitTarget.click();
  //   // Dom extensions need to be re-run after this, but that is handled by accounting_entries/reload_form.js.erb
  // }

  ensureLastRowIsEmpty() {
    var lastRow = this.entryFieldRowTargets.slice(-1)[0];
    if(lastRow && !this.rowIsEmpty(lastRow)) {
      this.addRow();
    }
  }

  rowIsEmpty(row) {
    var nonEmptyInputs = Array.from(row.getElementsByTagName('input')).some(inp => inp.value != "");
    return !nonEmptyInputs;
  }

  addRow() {
    // We used to just do a this.updateFormWithAjax(), and let the server add the new row. That became troublesome if
    // a new row was added by entering something into debit/credit and pressing enter, because that would create two
    // requests (one for a new row and one for submitting), which would make possible error messages dissappear.
    var lastRow = this.entryFieldRowTargets.slice(-1)[0];
    var newRow = lastRow.cloneNode(true);
    Array.from(newRow.getElementsByTagName('input')).forEach(inp => { 
      var row_index = inp.name.match(/accounting_rows_attributes\]\[(\d+)\]/)[1];
      if(row_index) {
        var new_row_index = parseInt(row_index) + 1;
        inp.name = inp.name.replace(/accounting_rows_attributes\]\[\d+\]/, 'accounting_rows_attributes][' + new_row_index + ']');
        inp.id = inp.id.replace(/accounting_rows_attributes_\d+_/, 'accounting_rows_attributes_' + new_row_index + '_');
        inp.value = "";
      }
    });
    lastRow.parentNode.appendChild(newRow);
  }

  sanitizeMoneyInputs() {
    this.debitFieldTargets.forEach(input => this.sanitizeMoneyInput(input));
    this.creditFieldTargets.forEach(input => this.sanitizeMoneyInput(input));
  }

  sumColumns() {
    var debitSum = this.safeMoneySum(this.debitFieldTargets.map(input => input.value));
    var creditSum = this.safeMoneySum(this.creditFieldTargets.map(input => input.value));
    return [debitSum, creditSum]
  }

  sumAndCompareColumns() {
    var [debitSum, creditSum] = this.sumColumns();
    this.debitSumTarget.innerHTML = this.moneyFormatter().format(debitSum);
    this.creditSumTarget.innerHTML = this.moneyFormatter().format(creditSum);
    this.showDiff(debitSum, creditSum);
  }

  showDiff(debitSum, creditSum) {
    if(debitSum.eq(creditSum)) {
      this.debitSumTarget.classList.remove(sumErrorClass);
      this.creditSumTarget.classList.remove(sumErrorClass);
    } else {
      this.debitSumTarget.classList.add(sumErrorClass);
      this.creditSumTarget.classList.add(sumErrorClass);
    }
  }

  clearValueIfNotANumber(event) {
    const inputField = event.target;
    if(parseInt(inputField.value).toString() != inputField.value) {
      inputField.value = '';
    }
  }

  sanitizeMoneyInput(input) {
    var numStr = input.value.replace(',','.').replace(/[^\.\d]/g, '').replace(/\s/g, '');
    if(isNaN(numStr) || numStr == '') {
      // If whatever we have is not a number, we leave it as it is (after sanitizing of non digits and commas)
      input.value = numStr;
    } else {
      // Now it's safe to pass to Big
      input.value = Big(numStr).toFixed(2);
    }
  }

  // Takes an array of strings representing numbers and sums them safely as money: 0.1 + 0.1 + 0.1 == 0.3 (not true for regular floats)
  safeMoneySum(numStrs) {
    return numStrs.filter(Number).map(numStr => Big(numStr)).reduce((accumulator, currentValue) => accumulator.plus(currentValue), Big('0'))
  }

  moneyFormatter() {
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
  }
}